<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <div class="bc_ico"><a href="JavaScript:" @click="goMain">{{$t('FIELD.GLOBAL.PAGEINFO.HOME')}}</a> <em><span class="sr_only">&gt;</span></em>{{$t('TITLE.SEARCH.RESULT.FOR')}} {{$t('FIELD.GLOBAL.CATEGORY')}}</div>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{$t('TITLE.SEARCH.RESULT.FOR')}} {{$t('FIELD.GLOBAL.CATEGORY')}}</h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap srch_result" :class="{extend: screenMode == 'D'}">
                <article class="srch_basic">
                    <dl class="dl_search">
                        <dd class="clearable" data-input-type="input">
                            <input type="text" class="search_input w100p" ref="kword" v-model="keyword" @keyup="onAutoCmpl"
                                   @keyup.enter.stop="clickBtnSearch(1)" @focus="inputFocus()" 
                                   placeholder="Enter a Model Code" v-regex="'/[^0-9a-zA-Z\-]/g'" v-clearable>
                            <i class="clearable_clear">X</i>
                        </dd>

                        <dd class="btn"><a href="JavaScript:" @click="clickBtnSearch(1)" class="btn_srch">Search</a></dd>
                        <dd v-if="searchMode != '0'" class="auto">
                            <!-- search autocomplete -->
                            <article class="srch_more">
                                <dl v-if="searchMode == '1' && recentModels && recentModels.length > 0" class="srch_history">
                                    <dt>{{$t('TITLE.SEARCH.RECENT.HISTORY')}}
                                        <a href="JavaScript:" class="link_line delete" @click="rowDelete({})">{{$t('FIELD.SEARCH.CLEAR.ALL')}}</a>
                                    </dt>
                                    <dd>
                                        <ul class="scroll"><!-- 200604수정(class추가) -->
                                            <li v-for="model in recentModels" :key="model.ID" :class="{active: model.ID == keyword}">
                                                <a href="JavaScript:" @click="clickRecentModels(model)">{{model.LABEL}}</a>
                                                <em><a href="JavaScript:" class="ico_gnb_delete" @click="rowDelete(model)"><span class="sr_only">delete</span></a></em>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                                <dl v-if="searchMode == '2' && autoCompletes && autoCompletes.length > 0" class="srch_autocomplete">
                                    <dd>
                                        <ul class="scroll"><!-- 200604수정(class추가) -->
                                            <li v-for="model in autoCompletes" :key="model.ID" :class="{active: model.ID == keyword}">
                                                <a href="JavaScript:" @click="keyword = model.ID">{{model.LABEL}}</a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                            </article>
                            <!-- //search autocomplete -->
                        </dd>
                    </dl>
                    <!-- mobile_hide -->
                    <div class="top_mobile">
                        <div class="mobile_title">Category</div>
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_white w100p" id="prod1" v-model="prodCateCd1" @change="changeProdCd(1)">
                                    <option value='' selected>{{$t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY')}}</option>
                                    <option v-for="code in prodCategories1" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_white w100p" id="prod2" v-model="prodCateCd2" @change="changeProdCd(2)">
                                    <option value='' selected>{{$t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY')}}</option>
                                    <option v-for="code in prodCategories2" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_white w100p" id="prod3" v-model="prodCateCd3">
                                    <option value='' selected>{{$t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY')}}</option>
                                    <option v-for="code in prodCategories3" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                                </select>
                            </dd>
                        </dl>
                    </div>
                    <!-- //mobile_hide -->
                </article>
                <a href="JavaScript:" class="btn_ico_srchBtm" @click="clickToggle"><span class="sr_only">toggle</span></a>
            </div>

            <!-- Grid -->
            <div class="grid_wrap">
                <div class="grid_total">Total Count : <em>{{resultCount | numberFormat}}</em></div>
                <div class="grid_total tabmobile_only">Search for <em v-html="naviName"></em></div>
                    <!-- Grid -->
                    <asc-list-grid
                        :gridId="gridId"
                        :data="gridData"
                        :columns="columns"
                        :options="options"
                        :pageOptions="pageOptions"
                        :key="gridKey"
                        :click="contentClick"
                        :isTotalCount="false"
                    />
                </div>
                <div class="paginate">
                    <sdl-pagination
                        :current-page="currentPage"
                        :total-rows="resultCount"
                        :per-page="perPage"
                        @change="onSearch"
                        align="center"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue              from 'vue';
import axios            from 'axios';
import qs               from 'query-string';
import _                from 'lodash';
import $                from 'jquery';
import moment           from 'moment';
import SDLPagination    from '~~c/control/pagination/Pagination';
import { SDLUtil }      from '@/utils';
import { EventBus }     from '@/utils/EventBus';
import AscToastGrid     from '~c/ToastGrid';

// 상세검색에서 사용
const fetchKnowledgeSetting = workType => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/listMyKnowledgeSetup.skp`,
    qs.stringify({ WORK_TYPE : workType }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'SearchAscList',
    props: {
//        params: {}
    },
    components: {
        'asc-list-grid'     : AscToastGrid
    },
    data() {
        return {
            isLoading: true,
            mode: 'search', // 'view'
            loadingStatus: 'loading', // 'done', 'error'
            keyword: '',
            cursorIndex: -1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            screenMode: 'B',
            searchMode: '1',
            recentModels: [],
            autoCompletes: [],
            gridData: [],
            gridId: 'AscGrid',
            currentPage: 1,
            gridKey: 1,
            resultCount: 0,
            pageOptions: {},
            ORDER_COLUMN: '',
            ORDER_DIR: '',
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'),
                    name: 'MODEL_CD',
                    align: 'center',
                    width: '200',
                    whiteSpace: 'normal',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.HME.MODEL.NAME'),
                    name: 'MODEL_NM',
                    align: 'center',
                    width: '200',
                    //width: 33%,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'),
                    name: 'MARKET_NM',
                    align: 'center',
                    width: '230',
                    //width: 34%,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.EXPVIEW.PROD.DESC'),
                    name: 'PROD_DESC',
                    align: 'left',
//                    width: '200',
                    sortable: true
                }
            ],            
            options: {
                scrollX: false,
                scrollY: false,
            },
            prodCateCd1: '',
            prodCateCd2: '',
            prodCateCd3: '',
            prodCateCd1Nm: '',
            prodCateCd2Nm: '',
            prodCateCd3Nm: '',
            prodCategories1: [],
            prodCategories2: [],
            prodCategories3: [],
            naviName: ''
        };
    },
    computed: {

    },
    methods: {
        async initRecentWords() {
            const param = {};

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/search/getRecentModels.skp`, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.recentModels = resp.data;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    console.log('Err.init ======> ', err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        // rowDelete, search(검색어 등록)
        async execServer(url, param) {
            return await axios
                .post(url, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    console.log('save result ==> ', resp.data);
                    this.init();
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        loadProducts(depth, param, initMode) {
            param.depth     = depth;
            return axios.post(
                `${SDLUtil.API_URL}/basis/admin/system/userRole/productCategories.skp`,
                qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                },
            ).then(resp => {
                if (depth == 1) { // product 1depth
                    this.prodCategories1 = resp.data;
                    this.prodCateCd1     = param.prodCateCd1;
                    param.parentCode     = this.prodCateCd1;
                    this.loadProducts(2, param, initMode);
                } else if (depth == 2) { // product 2depth
                    this.prodCategories2 = resp.data;
                    if (resp.data.length == 0) {
                        this.prodCateCd2   = '';
                        this.prodCateCd3   = '';
                    } else {
                        if (param.prodCateCd2) {
                            this.prodCateCd2 = param.prodCateCd2;
                            param.parentCode = this.prodCateCd2;
                            this.loadProducts(3, param, initMode);
                        } else {
//                          this.prodCateCd2 = resp.data[0].code;
                            this.prodCateCd2 = '';
                            this.prodCateCd3 = '';
                            this.prodCategories3 = [];
                        }
                    }
                } else if (depth == 3) { // product 3depth
                    this.prodCategories3 = resp.data;
                    if (resp.data.length == 0) {
                        this.prodCateCd3 = '';
                    } else {
                        if (param.prodCateCd3) {
                            this.prodCateCd3 = param.prodCateCd3;
                        } else {
//                          this.prodCateCd3 = resp.data[0].code;
                            this.prodCateCd3 = '';
                        }
                        if (initMode) this.onSearch(1);
                    }
                }
            }).catch(err => {
                console.log('Error occured : ', err);
            });
        },
        changeProdCd(depth) {
            let param = {codeCategoryId : 'PRODUCT_GROUP'
                        , parentCode: eval('this.prodCateCd' + depth)
                        , prodCateCd1: this.prodCateCd1
                        , depth : depth
                        };
            if (depth == 1) { // product code - 1Depth
                if (this.prodCateCd1 == '') {
                    this.prodCategories2 = [];
                    this.prodCategories3 = [];
                    this.prodCateCd2 = '';
                    this.prodCateCd3 = '';
                } else {
                    this.loadProducts(2, param, false);
                }
            } else if (depth == 2) { // product code - 2Depth
                param.prodCateCd2 = this.prodCateCd2;
                if (this.prodCateCd2 == '') {
                    this.prodCategories3 = [];
                    this.prodCateCd3 = '';
                } else {
                    this.loadProducts(3, param, false);
                }
            }
        },
        clickToggle() {
            this.screenMode = (this.screenMode == 'B') ? 'D' : 'B';
            this.$refs.kword.focus();
        },
        getSearchParams(pageNo, exclude = []) {
            if (!pageNo) pageNo = 1;
            
            let params = {
                page: pageNo,
                currentPage: pageNo,
                perPage : this.perPage,
                prodCateCd1 : this.prodCateCd1,
                prodCateCd2 : this.prodCateCd2,
                prodCateCd3 : this.prodCateCd3,
                modelNm :  this.keyword,
//                corpNo: $('#selectRhqSubCd').val(),
                ORDER_COLUMN: this.ORDER_COLUMN,
                ORDER_ASC: this.ORDER_DIR,
            };
            return params;
        },
        validation() {
            let msg = '';
            let bRes = true;
            if (!this.prodCateCd1) {
                msg = 'MESSAGE.SEARCH.NOSELECT.FIRST';
                bRes = false;
            } else if (!this.prodCateCd2) {
                msg = 'MESSAGE.SEARCH.NOSELECT.SECOND';
                bRes = false;
            }
            if (!bRes) {
                SDLUtil.alert(msg);
            }

            return bRes;
        },
        onSearch(pageNo) {
            if (!pageNo) pageNo = 1;

            if (!this.validation()) return false;

            const formData = this.getSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            this.gridData = [];
            return axios
                .post(`${SDLUtil.API_URL}/basis/search/getAscModelList.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.resultCount = resp.data.totalCount;
                    this.gridData = resp.data.rows;

                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        clickBtnSearch(page) {
            this.onSearch(page);
            this.searchMode = '0';
        },
        // 그리드 row 클릭 시... 상세페이지로 이동
        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;

            let item = this.gridData[event.rowKey];
            const param = { 
                  searchKind : 'C'
                , screenMode : 'B'
                , keyword    : item.MODEL_CD
            };
            let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/basis/intgSearch/SearchList`;
            this.$router.push({ path: pathUrl, query: param });
        },
        async onAutoComplete() {
            const param = { keyword: this.keyword };
            return await axios
                .post(`${SDLUtil.API_URL}/basis/search/getAutoComplete.skp`, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.autoCompletes = resp.data;
                    this.$refs.kword.focus();
                })
                .catch(err => {
                    console.log('Err.onAutoComplete ======> ', err);
                    SDLUtil.errorAlert(err);
                });
        },
        onAutoCmpl(event) {
            if (event.key == 'Enter' || event.key == 'Escape') return;

            // 상하 화살표 키
            if (event.key == 'ArrowUp' || event.key == 'ArrowDown') { // 위 화살표
                if (event.key == 'ArrowUp') this.cursorIndex -= 1;
                if (event.key == 'ArrowDown') this.cursorIndex += 1;

                if (this.cursorIndex < 0) {
                    if (this.searchMode == '1') { // 최근검색어
                        this.cursorIndex = this.recentModels.length - 1;
                    } else if (this.searchMode == '2') { // 자동완성
                        this.cursorIndex = this.autoCompletes.length - 1;
                    }
                }

                if (this.searchMode == '1') { // 최근검색어
                    if (this.cursorIndex >= this.recentModels.length) this.cursorIndex = 0;
                    if (this.recentModels.length > 0) {
                        this.keyword = this.recentModels[this.cursorIndex].ID;
                        this.searchKind = this.recentModels[this.cursorIndex].SRCH_KIND;
                    }
                } else if (this.searchMode == '2') { // 자동완성
                    if (this.cursorIndex >= this.autoCompletes.length) this.cursorIndex = 0;
                    if (this.autoCompletes.length > 0) this.keyword = this.autoCompletes[this.cursorIndex].ID;
                }

                return;
            }

            if (this.keyword.length > 0) this.keyword = this.keyword.toUpperCase();
            
            if (this.keyword.length > 2) { // 3자 이상이면...
                this.searchMode = '2';
                this.onAutoComplete();
            } else if (this.keyword.length < 1) { // 2자 이하면 최근검색어 나오게..
                this.searchMode = '1';
            } else {
                this.searchMode = '0';
            }

            if (this.keyword.length > 0) {
                this.keyword = this.keyword.toUpperCase();

                let naviNm = '';
                if (this.prodCateCd1) naviNm = $('#prod1 option:selected').text();
                if (this.prodCateCd2) naviNm += ' > ' + $('#prod2 option:selected').text();
                if (this.prodCateCd3) naviNm += ' > ' + $('#prod3 option:selected').text();
                this.naviName = naviNm + ' : ' + this.keyword;
            }

        },
        clickRecentModels(model) {
            this.keyword = model.ID; 
            this.searchKind = model.SRCH_KIND;
            this.searchMode = '0';
        },
        rowDelete(row) {
            let newList = [];
            this.recentModels.forEach(elm => {
                if (elm.ID != row.ID) newList.push(elm);
            });
            this.recentModels = newList;

            const url = `${SDLUtil.API_URL}/basis/search/deleteRecentModel.skp`;
            const param = { keyword : row.ID };
            this.execServer(url, param);
        },
        inputFocus() {
            if (this.keyword.length == 0)  {
                this.searchMode = '1';
            }
        },
        // Sidebar 에서 카테고리 선택 후 카테고리 적용하여 컨텐츠 목록 재조회
        setCategory(v) {
            let param = {
                prodCateCd1 : v.prodCateCd1 || '',
                prodCateCd2 : v.prodCateCd2 || '',
                prodCateCd3 : v.prodCateCd3 || ''
            }
            this.loadProducts(1, param, true);
        },
        // 모델코드 선택
        setSelectModel(model = '') {
            this.keyword = model;
        },
        goMain() {
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
        },
    }, // methods
    watch: { // keyword를 clearable로 지웠을 때...
        // Change of date unit
        keyword() {
            if (this.keyword.trim() == '') {
                this.cursorIndex = -1;
                this.onAutoCmpl({key:''});
                this.$refs.kword.focus();
            }
        },
    },
    created() {
        this.params = this.$route.query; // 검색팝업에서 받은 params
        EventBus.$on('quick-category', v => { this.setCategory(v); });
        EventBus.$on('select-recent-model', model => { this.setSelectModel(model); });
    },
    mounted() {
        console.log('AscList.mounted.this.params ==> ', this.params);
//        this.prodCateCd1 = this.params.prodCateCd1;
//        this.prodCateCd2 = this.params.prodCateCd2;
//        this.prodCateCd3 = this.params.prodCateCd3;

        this.initRecentWords(); // 최근검색어 조회

        this.searchMode = '0';
        
        this.params.depth = 1;
        this.loadProducts(1, this.params, true);
//        this.$refs.kword.focus();
    },
    beforeDestroy() {
        EventBus.$off('quick-category');
        EventBus.$off('select-recent-model');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/intgSearch/SearchAscList.vue